module.exports = __webpack_public_path__ + "static/media/caetsu.245e8ad5.jpg";